import React from 'react';
import { Check, MessageCircle, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden section-glow" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 md:px-6 w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-209">
        <div className="space-y-8 reveal" data-id="element-210">
          <div className="space-y-4" data-id="element-211">
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight" data-id="element-212">
              Professional Business Website —{' '}
              <span className="gold-gradient-text" data-id="element-213">Done For You</span>
            </h1>
            <p className="text-lg md:text-xl text-white/70 max-w-xl" data-id="element-214">
              Built for Dublin businesses. Premium look, fast launch, made to
              convert.
            </p>
          </div>

          <ul className="space-y-4" data-id="element-215">
            {['Done-for-you build — no tech skills needed', 'AI editing after launch — 100 monthly requests', '1-year Hobby plan included — $180 value', '1 year of hosting + direct support included'].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-216">
                <div className="mt-1 bg-[#c9a84c]/20 p-1 rounded-full" data-id="element-217">
                  <Check className="w-4 h-4 text-[#c9a84c]" data-id="element-218" />
                </div>
                <span className="text-white/90" data-id="element-219">{item}</span>
              </li>)}
          </ul>

          <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-220">
            <a href="https://wa.me/36707559881?text=Hi%2C%20I%27m%20in%20Dublin.%20I%20want%20the%20%E2%82%AC249%20website%20package.%20My%20business%20is%3A%20____" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2 bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 shadow-lg shadow-green-900/20" data-id="element-221">
              <MessageCircle className="w-6 h-6" data-id="element-222" />
              <span data-id="element-223">Get Started on WhatsApp</span>
            </a>
            <a href="#contact" className="flex items-center justify-center space-x-2 border border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c]/10 px-8 py-4 rounded-lg font-medium text-lg transition-all" data-id="element-224">
              <span data-id="element-225">Get a Quote</span>
              <ArrowRight className="w-5 h-5" data-id="element-226" />
            </a>
          </div>
          <p className="text-sm text-white/50 ml-2" data-id="element-227">
            ⚡ Fast reply • Typically within 1 hour
          </p>
        </div>

        <div className="relative reveal" data-id="element-228">
          <div className="absolute -inset-1 bg-gradient-to-r from-[#c9a84c] to-[#8a7030] rounded-2xl blur opacity-20" data-id="element-229"></div>
          <div className="relative gold-border-card p-8 md:p-10 rounded-xl space-y-8" data-id="element-230">
            <div className="text-center space-y-2" data-id="element-231">
              <p className="text-[#c9a84c]/80 uppercase tracking-widest text-sm font-medium" data-id="element-232">
                Dublin Launch Package
              </p>
              <span className="text-6xl font-bold text-white block" data-id="element-233">€249</span>
              <p className="text-[#c9a84c] font-medium" data-id="element-234">
                All Included • One-time payment
              </p>
            </div>

            <div className="border-t border-white/10 pt-6" data-id="element-235">
              <div className="flex items-center justify-between mb-2" data-id="element-236">
                <span className="text-sm text-white/80" data-id="element-237">
                  Limited Availability
                </span>
                <span className="text-sm text-[#c9a84c] font-bold" data-id="element-238">
                  Only 5 spots this month
                </span>
              </div>
              <div className="flex space-x-2 justify-center" data-id="element-239">
                {[1, 2].map(i => <div key={i} className="h-2 w-full bg-[#c9a84c] rounded-full" data-id="element-240"></div>)}
                {[3, 4, 5].map(i => <div key={i} className="h-2 w-full border border-[#c9a84c]/30 rounded-full" data-id="element-241"></div>)}
              </div>
              <p className="text-center text-sm text-white/50 mt-3" data-id="element-242">
                High demand in Dublin area. Secure your spot today.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}